"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashMapFilterFactory = void 0;
var hashMapFilterFactory = function (_a) {
    var _b = _a.minLength, minLength = _b === void 0 ? 2 : _b, _c = _a.caseSensitive, caseSensitive = _c === void 0 ? false : _c, fieldsOfInterest = _a.fieldsOfInterest;
    return function (search) { return function (input) {
        if (search.length < minLength)
            return true;
        return fieldsOfInterest.some(function (f) {
            var toMatch = input[f];
            if (caseSensitive) {
                return toMatch.includes(search);
            }
            else {
                return toMatch.toLowerCase().includes(search.toLowerCase());
            }
        });
    }; };
};
exports.hashMapFilterFactory = hashMapFilterFactory;
//# sourceMappingURL=hashMapFilter.js.map